import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OfferServiceBasicDTO } from 'src/app/dashboard/services/models/services/service-basic-dto';
import { OfferRetailProductBasicDTO } from 'src/app/dashboard/stock/products/models/retail-product-basic-dto';
import { SharedService } from 'src/app/services/other/shared.service';

@Injectable({
  providedIn: 'root',
})
export class PackageServicesService {
  servicePackage$: BehaviorSubject<OfferServiceBasicDTO[]> =
    new BehaviorSubject<OfferServiceBasicDTO[]>([]);
  productPackage$: BehaviorSubject<OfferRetailProductBasicDTO[]> =
    new BehaviorSubject<OfferRetailProductBasicDTO[]>([]);

  constructor(
    private sharedService: SharedService
  ) {
  }

  fixedNumber(src: number) : number {
    const numberSrc = Number(src);
    const fixedNumber = numberSrc > 0 ? Number(numberSrc.toFixed(this.sharedService.GetFractionRoundCount)) : 0;
    return fixedNumber;
  }

  setServicePackage(services: OfferServiceBasicDTO[]) {
    this.servicePackage$.next(services);
  }

  getServicePackage(): OfferServiceBasicDTO[] {
    return this.servicePackage$.value;
  }

  removeServicePackageById(id: number) {
    const services = this.servicePackage$.value.filter(s => s.ServiceId !== id);
    this.servicePackage$.next(services);
  }

  setProductPackage(products: OfferRetailProductBasicDTO[]) {
    this.productPackage$.next(products);
  }

  getProductPackage(): OfferRetailProductBasicDTO[] {
    return this.productPackage$.value;
  }

  removeProductPackageById(id: number) {
    const products = this.productPackage$.value.filter(
      (p) => p.ProductId !== id
    );
    this.productPackage$.next(products);
  }

  // applyExactDiscountToItems(PriceAfterDiscount: number): {
  //   services: OfferServiceBasicDTO[];
  //   products: OfferRetailProductBasicDTO[];
  // } {
  //   const items = [
  //     ...this.servicePackage$.value,
  //     ...this.productPackage$.value,
  //   ];

  //   // استخدم المجموع بناءً على السعر * الكمية
  //   const totalOriginalValue = items.reduce((sum, item) => {
  //     const quantity = Number(item.Quantity) || 1;
  //     return sum + (item.Price * quantity);
  //   }, 0);

  //   const targetTotalPrice = PriceAfterDiscount || 0;
  //   if (totalOriginalValue === targetTotalPrice) {
  //     const services = items.filter((item) => 'ServiceId' in item) as OfferServiceBasicDTO[];
  //     const products = items.filter((item) => 'ProductId' in item) as OfferRetailProductBasicDTO[];
  //     return { services, products };
  //   }
    
  //   const itemsWithDiscount = items.map((item) => {
  //     const quantity = Number(item.Quantity) || 1;
  //     const itemTotal = item.Price * quantity;
  //     const itemShare = itemTotal / totalOriginalValue;
  //     const newTotalPrice = itemShare * targetTotalPrice;
  //     const newUnitPrice = newTotalPrice / quantity;
  //     if ('ServiceId' in item) {
  //       return {
  //         ...item,
  //         Price: newUnitPrice,
  //         totalPrice: newTotalPrice,
  //         fixedPrice: this.fixedNumber(newUnitPrice)
  //       } as OfferServiceBasicDTO;
  //     } else {
  //       return {
  //         ...item,
  //         Price: newUnitPrice,
  //         totalPrice: newTotalPrice,
  //         fixedPrice: this.fixedNumber(newUnitPrice)
  //       } as OfferRetailProductBasicDTO;
  //     }
  //   });

  //   // حساب المجموع الفعلي الجديد بعد التقريب
  //   const finalTotal = itemsWithDiscount.reduce(
  //     (sum, item) => sum + (item.Price * (Number(item.Quantity) || 1)),
  //     0
  //   );
  //   const difference = targetTotalPrice - finalTotal;
  //   if (difference !== 0 && itemsWithDiscount.length > 0) {
  //     const firstItem = itemsWithDiscount[0];
  //     const quantity = Number(firstItem.Quantity) || 1;
  //     const diffPerUnit = difference / quantity;
  //     firstItem.fixedPrice = this.fixedNumber(firstItem.Price + diffPerUnit);
  //     firstItem.Price = firstItem.Price + diffPerUnit;
  //     firstItem.totalPrice = firstItem.Price * quantity;
  //   }

  //   const services = itemsWithDiscount.filter((item) => 'ServiceId' in item) as OfferServiceBasicDTO[];
  //   const products = itemsWithDiscount.filter((item) => 'ProductId' in item) as OfferRetailProductBasicDTO[];

  //   // Emit updated values
  //   this.servicePackage$.next(services);
  //   this.productPackage$.next(products);
  //   return { services, products };
  // }
  applyDiscount(discountPrice:number) {
    const allItems = [
      ...this.servicePackage$.value.map(item => ({ ...item, type: 'service' })),
      ...this.productPackage$.value.map(item => ({ ...item, type: 'product' }))
    ];
    const services = allItems.filter(item => item.type === 'service') as OfferServiceBasicDTO[];
    const products = allItems.filter(item => item.type === 'product') as OfferRetailProductBasicDTO[];
    // حساب مجموع basicPrice لجميع العناصر
    const totalBasicPrice = allItems.reduce((sum, item) => sum + item.basicPrice, 0);
  
    // إذا كان المجموع صفر، لا يمكن تطبيق الخصم
    if (totalBasicPrice === 0) {
      return { services, products };
    }
  
    // توزيع discountPrice على العناصر بناءً على نسبة basicPrice
    const updatedItems = allItems.map(item => {
      const priceRatio = item.basicPrice / totalBasicPrice;
      const newPrice = discountPrice * priceRatio;
  
      return {
        ...item,
        Price: newPrice,
        totalPrice: newPrice * item.Quantity,
        fixedPrice: this.fixedNumber(newPrice)
      };
    });
  
    // فصل العناصر المحدثة إلى services و products
    const updatedServices = updatedItems
      .filter(item => item.type === 'service')
      .map(({ type, ...rest }) => rest);
    const updatedProducts = updatedItems
      .filter(item => item.type === 'product')
      .map(({ type, ...rest }) => rest);
  
    // التحقق من أن مجموع totalPrice يساوي discountPrice
    const totalNewPrice = updatedItems.reduce((sum, item) => sum + item.totalPrice, 0);
    if (Math.abs(totalNewPrice - discountPrice) > 0.01) {
      console.warn(`Warning: Total price (${totalNewPrice}) does not exactly match discountPrice (${discountPrice}) due to rounding errors.`);
    }
  
    console.log('updatedServices',updatedServices);
    console.log('updatedProducts',updatedProducts);
    this.servicePackage$.next(updatedServices as OfferServiceBasicDTO[]);
    this.productPackage$.next(updatedProducts as OfferRetailProductBasicDTO[]);
    return {
      services: updatedServices,
      products: updatedProducts
    };
  }

  changeServiceFields(serviceId: number, fieldsToUpdate: Partial<OfferServiceBasicDTO>): void {
    this.servicePackage$.next(
      this.servicePackage$.value.map(service =>
        service.ServiceId === serviceId
          ? { ...service, ...fieldsToUpdate, fixedPrice: this.fixedNumber(fieldsToUpdate.Price), totalPrice: fieldsToUpdate.Price * fieldsToUpdate.Quantity }
          : service
      )
    );
  }

  changeProductFields(productId: number, fieldsToUpdate: Partial<OfferRetailProductBasicDTO>): void {
    this.productPackage$.next(
      this.productPackage$.value.map(product =>
        product.ProductId === productId
          ? { ...product, ...fieldsToUpdate, fixedPrice: this.fixedNumber(fieldsToUpdate.Price), totalPrice: fieldsToUpdate.Price * fieldsToUpdate.Quantity }  // دمج الخصائص الجديدة مع القديمة
          : product
      )
    );
  }

}
